module.exports = __webpack_public_path__ + "static/media/mirage-teamwork.22b9659b.png";